export const NAV_DATA_KEY = 'nav-data';
export const HEROKU_BOOMERANG_BAR_HEIGHT = 32;
